// @flow

// Effect Managers
import { call, fork } from 'redux-saga/effects'

import { watchOperations } from 'hfty-operator-contact-us'

// Controller
import controller from 'hfty-ctrl-contact-us'

export default function *main (): Generator<*, *, *> {
  yield call(controller.start)
  yield fork(controller.watch)
  yield fork(watchOperations)
}
